  import i18n from '@/libs/i18n';

export default [
  // {
  //   get header() {
  //     return i18n.t('common.dashboard');
  //   },
  // },
 
];
